export default __webpack_public_path__ + "e15656aad96d85e04660495e3d04b0ac.png";